import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const attemptConnectorFileUploadEvent = EVENT_PAYLOAD;
export const connectorAuthFlowStartedEvent = EVENT_PAYLOAD;
export const connectorAuthRetrySelectedEvent = EVENT_PAYLOAD;
export const connectorStateUpdatedEvent = EVENT_PAYLOAD;
export const CONNECTOR_OAUTH_SCOPES_SAVED_EVENT_NAME = 'connector oauth scopes saved';
export const CONNECTOR_OAUTH_SCOPE_LIST_TOGGLED_EVENT_NAME = 'connector oauth scope list toggled';
export const CONNECTOR_OAUTH_SCOPES_BULK_CHANGED_EVENT_NAME = 'connector oauth scopes bulk changed';
export const CONNECTOR_OAUTH_SCOPE_TOGGLED_EVENT_NAME = 'connector oauth scope toggled';
//# sourceMappingURL=analytics.js.map